var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled, { css } from 'styled-components';
import { Button } from '../Button';
export var AccordionHeader = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  letter-spacing: -0.1px;\n  justify-content: ", ";\n  color: ", ";\n  ", "\n\n  & > div:first-child {\n    display: flex;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  letter-spacing: -0.1px;\n  justify-content: ", ";\n  color: ", ";\n  ", "\n\n  & > div:first-child {\n    display: flex;\n  }\n\n  ", "\n"])), function (_a) {
  var titleCentered = _a.titleCentered;
  return titleCentered ? 'center' : 'space-between';
}, function (_a) {
  var color = _a.color,
    theme = _a.theme;
  return color ? color : theme.tokens.text.label.regular;
}, function (_a) {
  var hasRichContent = _a.hasRichContent;
  return !hasRichContent ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          font-size: 16px;\n          line-height: 24px;\n        "], ["\n          font-size: 16px;\n          line-height: 24px;\n        "]))) : '';
}, function (_a) {
  var customClickableWrapper = _a.customClickableWrapper;
  return !customClickableWrapper && {
    position: 'relative'
  };
});
export var AccordionHeaderContent = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  min-height: 16px;\n\n  ", "\n\n  :focus {\n    outline-offset: 2px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  min-height: 16px;\n\n  ", "\n\n  :focus {\n    outline-offset: 2px;\n  }\n"])), function (_a) {
  var fullWidth = _a.fullWidth;
  return fullWidth ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          width: 100%;\n        "], ["\n          width: 100%;\n        "]))) : '';
});
export var AccordionTitle = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n"])));
export var AccordionMainTitle = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex-basis: 220px;\n  margin-right: 20px;\n"], ["\n  flex-basis: 220px;\n  margin-right: 20px;\n"])));
export var AccordionSubtitle = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex-grow: 1;\n  flex-basis: 200px;\n"], ["\n  flex-grow: 1;\n  flex-basis: 200px;\n"])));
export var ArrowContainer = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
});
export var AdditionalText = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding-left: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  white-space: nowrap;\n"], ["\n  padding-left: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  white-space: nowrap;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.md;
});
export var AccordionContent = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin-top: ", ";\n  color: ", ";\n  font-size: 13px;\n  line-height: 20px;\n"], ["\n  margin-top: ", ";\n  color: ", ";\n  font-size: 13px;\n  line-height: 20px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
}, function (_a) {
  var color = _a.color,
    theme = _a.theme;
  return color ? color : theme.tokens.text.paragraph.light;
});
export var accordionComponent = function (theme) {
  return "\n  border-bottom: 1px solid ".concat(theme.tokens.interface.neutral.light, ";\n  padding: 20px 0;\n");
};
export var accordionHeaderContent = function (withoutHeaderMargin) {
  return "\n  justify-content: space-between;\n  width: 100%;\n  margin: ".concat(withoutHeaderMargin ? 0 : '0 8px', ";\n");
};
export var arrowContainer = function () {
  return "\n  align-self: center;\n";
};
export var AccordionComponent = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n  ", " {\n    ", "\n  }\n  ", " {\n    ", "\n  }\n"], ["\n  ", "\n  ", " {\n    ", "\n  }\n  ", " {\n    ", "\n  }\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'list' ? accordionComponent(theme) : '';
}, AccordionHeaderContent, function (_a) {
  var variant = _a.variant,
    withoutHeaderMargin = _a.withoutHeaderMargin;
  return variant === 'list' ? accordionHeaderContent(withoutHeaderMargin) : '';
}, ArrowContainer, function (_a) {
  var variant = _a.variant;
  return variant === 'list' ? arrowContainer() : '';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;